import { styled } from '@mui/material/styles';
import { Button } from '@mui/material';
import KeyboardArrowDownIcon from '@mui/icons-material/KeyboardArrowDown';

const StyledButton = styled(Button)`
  border: 1px solid #e0e2e8;
  border-radius: 4px;
  color: #000;
  font-weight: 500;
  font-size: 12px;
  text-align: left;
  justify-content: space-between;

  &:active,
  &:hover {
    border: 1px solid #e0e2e8;
  }

  &:disabled {
    opacity: 0.5;
  }
`;

function FilterButton({ open, ...props }) {
  return (
    <StyledButton
      endIcon={<KeyboardArrowDownIcon sx={{ transform: `rotate(${open ? '180deg' : '0deg'})` }} />}
      variant="outlined"
      {...props}
    />
  );
}

export default FilterButton;
